// ⚖️ services/legal.js — the Terms, the Privacy Policy, my age and my email choice as the SERVER keeps
// them (server/functions/legal.js → legalVault/{uid}; only the server writes it). The twin of the
// phone's services/legalApi.ts.
//
// 🟥 The web wrote the date of birth itself (vibeSocial.saveMyDob → users/{uid}/private/dob), a
//    document its owner may rewrite — so the Vibes age was whatever a browser last said.
// 🟢 The date goes to the server, once; it keeps the 16th birthday the Vibes routes and the post rule
//    check. Product-news emails are a switch here and in the phone's Settings → Terms & Policies.
import { auth } from '../config/firebase';
import { BACKEND_URL } from './socket';

export const LEGAL_URLS = {
  terms: '/terms', privacy: '/privacy', guidelines: '/community-guidelines',
  cookies: '/cookies', deleteAccount: '/delete-account', legal: '/legal',
};

async function post(path, body) {
  const u = auth.currentUser;
  if (!u || u.isAnonymous) return { ok: false, error: 'failed' };
  let r;
  try {
    r = await fetch(`${BACKEND_URL}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${await u.getIdToken()}` },
      body: JSON.stringify(body || {}),
    });
  } catch { return { ok: false, error: 'network' }; }
  let j = null;
  try { j = await r.json(); } catch { /* not json */ }
  if (r.ok && j) return { ok: true, ...j };
  const e = String((j && j.error) || '');
  return { ok: false, error: ['underage', 'dob_required', 'dob_locked', 'bad_dob'].includes(e) ? e : 'failed' };
}

export const legalStatus = () => post('/api/legal/status', {});
export const sendDob = (dob, gender) => post('/api/legal/dob', { dob, gender });
export const setMarketingEmails = (optIn) => post('/api/legal/marketing', { optIn, source: 'web-settings' });

/** The calendar day picked (local), as the server reads it. */
export const dobOf = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
